import { Button, Input } from '@cokitchen/cokitchen-components';
import React, { FC, useEffect, useRef, useState } from 'react';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import LocalModal from 'components/base/local-modal';
import { STORAGE_KEYS } from 'utils/constants';
import useOrdersContext from 'contexts/orders.context';

type AddNewNumberModalProps = {
  show: boolean;
  onClose: () => void;
};

const AddNewNumberModal: FC<AddNewNumberModalProps> = ({ show, onClose }) => {
  const { calculatedOrderForm, setcalculatedOrderForm } = useOrdersContext();
  const [useDefault, setUseDefault] = useState(true);
  const [customNo, setCustomNo] = useState('');
  const phoneNumber = localStorage.getItem(STORAGE_KEYS.PHONE_NUMBER) || '';
  const handleClose = () => {
    onClose();
  };
  const customInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!useDefault && customInputRef.current) {
      customInputRef.current.focus();
    }
  }, [useDefault]);
  const updatePhoneNumber = () => {
    if (calculatedOrderForm.address_details) {
      setcalculatedOrderForm({
        ...calculatedOrderForm,
        address_details: {
          ...calculatedOrderForm.address_details,
          phone_number: useDefault ? phoneNumber : customNo
        }
      });
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='What number should we call? '
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div>
          <p className='text-gray-4 text-xs'>Default phone number</p>
          <div className='pl-2 pr-2 h-[40px] border mt-3 border-[#E5E6E6] flex items-center gap-4'>
            <PhoneIcon />
            <input
              className='mt-2 border border-white   pb-1 text-gray-6 rounded-lg  focus:outline-none'
              type='text'
              value={phoneNumber}
              readOnly
            />
            <Input
              type='radio'
              className='ml-auto'
              checked={useDefault === true}
              onChange={() => {
                setUseDefault(true);
              }}
            />
          </div>
        </div>
        <div>
          <p className='text-gray-4 text-xs pt-4'>Custom phone number</p>
          <div
            className={`pl-2 pr-2 h-[40px] border mt-3  flex items-center gap-4  ${
              useDefault ? 'border-[#E5E6E6]' : 'border-red-2'
            }`}>
            <PhoneIcon />
            <input
              className='mt-2 border border-white pb-1 text-gray-6 rounded-lg  focus:outline-none'
              type='number'
              placeholder='070********'
              maxLength={11}
              value={customNo}
              onChange={(e) => setCustomNo(e.target.value.slice(0, 11))}
              ref={customInputRef}
            />
            <Input
              type='radio'
              className='ml-auto'
              checked={useDefault === false}
              onChange={() => {
                setUseDefault(false);
              }}
            />
          </div>
        </div>
      </div>
      <div className='mt-5 flex justify-end'>
        <Button
          color='gray'
          variant='block'
          className='mr-4 w-[139px] h-[41px]'
          onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='block'
          className='w-[139px] h-[41px]'
          onClick={() => {
            updatePhoneNumber();
            handleClose();
          }}>
          Save
        </Button>
      </div>
    </LocalModal>
  );
};

export default AddNewNumberModal;
